import { apiInstance } from "./api"

const endpoint = "/layout"

export const getLayout = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(endpoint)

  return response.data
}
